import { useMutation } from '@tanstack/react-query';

import { shareOffer } from '../../../../common/api/clients/export.api';

export const useShareOffer = () => {
    return useMutation({ mutationFn: shareOffer });
};
